import { Skeleton } from "@/components/ui/skeleton";

function NavbarSkeleton() {
  return (
    <>
      <div className="">
        <nav className="w-full fixed bg-system-white ease-in-out opacity-100 z-50 top-0">
          <div className="border-b border-midnightIndigo-200 top-0">
            <div className="p-4 lg:px-11 lg:py-[22px] flex justify-between items-center w-full mx-auto max-w-[1440px] h-[56px] lg:h-[86px]">
              {/* Logo Skeleton */}
              <div>
                <Skeleton className="w-[111px] h-[24px] sm:w-[118px] sm:h-[25px] md:w-[155px] md:h-[34px] lg:h-[42px]" />
              </div>

              {/* Search Bar Skeleton */}
              <div className="hidden md:block md:ml-[20px] lg:ml-[60px]">
                <Skeleton className="h-[42px] w-[400px] lg:w-[600px]" />
              </div>

              {/* Right Side Items Skeleton */}
              <ul className="flex gap-3 md:gap-6 py-4 items-center">
                <li>
                  <Skeleton className="h-8 w-8 rounded-full" />
                </li>
                <li className="hidden lg:flex">
                  <Skeleton className="w-[1px] h-[29px]" />
                </li>
                <li className="mr-[12px]">
                  <Skeleton className="h-8 w-8" />
                </li>
                <li className="hidden md:flex">
                  <Skeleton className="h-8 w-8" />
                </li>
                <li className="flex md:hidden">
                  <Skeleton className="h-8 w-8" />
                </li>
                <li className="block lg:hidden">
                  <Skeleton className="h-8 w-8" />
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Menu Skeleton */}
          <div className="shadow lg:border-b-[1px] border-midnightIndigo-200">
            <div className="py-6 px-11 h-[68px] top-0 w-full mx-auto max-w-[1440px] hidden lg:flex gap-6">
              {[1, 2, 3, 4, 5, 6].map(item => (
                <Skeleton key={item} className="h-6 w-24" />
              ))}
            </div>
          </div>
        </nav>
      </div>
      <div className="h-[56px] md:h-[60px] lg:h-[155px]" />
    </>
  );
}

export default NavbarSkeleton;
